import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { GuardService } from 'app/shared/services/guard/guard.service';

import { SashaEntryPoints } from './sasha-entry-points';
import { SashaHomeComponent } from './pages/sasha-home/sasha-home.component';
import { ProcessReportPageModule } from "app_sasha/pages/process-report/process-report-page.module";

const routes: Routes = [
    {
        path: '',
        redirectTo: SashaEntryPoints.home,
        pathMatch: 'full',
    },
    {
        path: SashaEntryPoints.home,
        component: SashaHomeComponent,
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.booking}`,
        loadChildren: () => import('./pages/booking/booking.module').then(m => m.BookingModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.booking}/search`,
        loadChildren: () => import('./pages/booking-search/booking-search.module').then(m => m.BookingSearchModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.booking}/search-result`,
        loadChildren: () => import('./pages/booking-search-result/booking-search-result.module').then(m => m.BookingSearchResultModule),
        canActivate: [GuardService]
    },
    {
        path: `${SashaEntryPoints.ticketingReport}`,
        loadChildren: () => import('./pages/ticketing-report/ticketing-report-page.module').then(m => m.TicketingReportPageModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.processReport}`,
        loadChildren: () => import('./pages/process-report/process-report-page.module').then(m => m.ProcessReportPageModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.bookingInTicketingReport}`,
        loadChildren: () => import('./pages/booking-in-ticketing-report/booking-in-ticketing-report.module').then(m => m.BookingInTicketingReportModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.bookingInTicketingReport}/search-result`,
        loadChildren: () => import('./pages/booking-in-ticketing-report-search-result/booking-in-ticketing-report-search-result.module').then(m => m.BookingInTicketingReportSearchResultModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.importBooking}`,
        loadChildren: () => import('./pages/import-booking/import-booking.module').then(m => m.ImportBookingModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.booking}/:syscode`,
        loadChildren: () => import('./pages/booking-details/booking-details.module').then(m => m.BookingDetailsModule),
        canActivate: [GuardService],
        // data: { permissionPath: 'sasha.booking.detail.view', redirectTo : '/sasha/home' },
    },
    {
        path: `${SashaEntryPoints.booking}/:syscode/:offerId`,
        loadChildren: () => import('./pages/booking-details/booking-details.module').then(m => m.BookingDetailsModule),
        canActivate: [GuardService],
        // data: { permissionPath: 'sasha.booking.detail.view', redirectTo : '/sasha/home' },
    },
    {
        path: `${SashaEntryPoints.processing}/search`,
        loadChildren: () => import('./pages/processing-search/processing-search.module').then(m => m.ProcessingSearchModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.processing}/search-result`,
        loadChildren: () => import('./pages/processing-search-result/processing-search-result.module').then(m => m.ProcessingSearchResultModule),
        canActivate: [GuardService]
    },
    {
        path: `${SashaEntryPoints.processing}/:id`,
        loadChildren: () => import('./pages/processing-detail/processing-detail.module').then(m => m.ProcessingDetailModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.processing}/:processingid/booking/:syscode`,
        loadChildren: () => import('./pages/booking-details/booking-details.module').then(m => m.BookingDetailsModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.processingQualityCheck}`,
        loadChildren: () => import('./pages/processing-quality-check/processing-quality-check.module').then(m => m.ProcessingQualityCheckModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.processingIssuing}`,
        loadChildren: () => import('./pages/processing-issuing/processing-issuing.module').then(m => m.ProcessingIssuingModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.processingCancel}`,
        loadChildren: () => import('./pages/processing-cancellation/processing-cancellation.module').then(m => m.ProcessingCancellationModule),
        canActivate: [GuardService],
    },
    {
        path: `${SashaEntryPoints.processingVoiding}`,
        loadChildren: () => import('./pages/processing-voiding/processing-voiding.module').then(m => m.ProcessingVoidingModule),
        canActivate: [GuardService],
    },
    {
        path: SashaEntryPoints.processingEmail,
        loadChildren: () => import('./pages/processing-email/processing-email.module').then(m => m.ProcessingEmailModule),
        canActivate: [GuardService],
    },
    {
        path: SashaEntryPoints.processingSms,
        loadChildren: () => import('./pages/processing-sms/processing-sms.module').then(m => m.ProcessingSmsModule),
        canActivate: [GuardService],
    },
    // KEEP THIS COMMENT, add routes ABOVE ↑ ↑ ↑ ↑
    // When adding a route, please check that the route is lazily loaded:
    //
    // 1. Navigate to the route that allows to access your new route
    // 2. Open the dev tools in your browser, display the network tab
    // 3. Click on the button/link that will make you load the new route
    // 4. Verify that a chunk has beed loaded just after you clicked
    //
    // If routes are not lazily loaded, the home page will take more and more time
    // An important work has been done to make it possible, please continue
    // in the same direction
    // Problems might arise when trying to access a service with shared data
    // between lazy loaded routes (in general 2 instances of the service are created)
    // refer to the module here: app_sasha/shared/services/processing/processing.module.ts
    // to see how to only load the module once (and reference it in sasha's main module)
    {
        path: '**',
        redirectTo: SashaEntryPoints.home,
    },
];

@NgModule({
    imports: [
        // /!\ BEWARE
        // DO NOT import routes modules here
        // otherwise the lazy loading of routes will not work
        RouterModule.forChild(routes),
    ],
    exports: [
        RouterModule,
    ],
})
export class SashaRoutingModule { }
